// Vendor imports
const _ = require('lodash')
const { createSelector } = require('reselect')
// Client V2 common imports
const { NextPageStateEnum } = require('client-v2/common/utils/enums')

const containerState = state => state.collectionEditCoverImageModal

const isVisible = createSelector(
  containerState,
  Boolean
)

const isNextPageAvailable = createSelector(
  containerState,
  s => _.get(s, 'nextPageState') === NextPageStateEnum.AVAILABLE
)

const isNextPagePending = createSelector(
  containerState,
  s => _.get(s, 'nextPageState') === NextPageStateEnum.LOADING
)

const images = createSelector(
  containerState,
  s => _.get(s, 'images', [])
)

const nextPageNumber = createSelector(
  containerState,
  s => _.get(s, 'nextPageNumber', 1)
)

module.exports = {
  // Flags
  isNextPageAvailable,
  isNextPagePending,
  isVisible,
  // Values
  containerState,
  images,
  nextPageNumber
}
